import LSS from "./localStorageService";
export const canCreateShifts = () => {
    return LSS().get("business_permissions").sites_with_manage_permission > 0;
};

export const canInviteSite = () => {
    return LSS().get("business_permissions").sites_with_invite_permission > 0;
};
